import React from 'react';
import AdminRouteGuard from '../../components/guards/AdminRouteGuard';
import EditSystemUserPage from './EditSystemUserPage';

const EditSystemUserPageWrapper: React.FC = () => {
  return (
    <AdminRouteGuard>
      <EditSystemUserPage />
    </AdminRouteGuard>
  );
};

export default EditSystemUserPageWrapper;